<template>
    <k-select
        :disabled="disabled"
        ref="allergies"
        :label="trans('general.page.children.add_allergies')"
        :placeholder="trans('general.page.children.add_allergies')"
        :multiple="true"
        :show-tags="2"
        :server-side-search="true"
        :show-selected-options="true"
        v-model="selected"
        :options="options"
        :search-help="trans('general.page.children.add_allergies_help')"
        v-on:search-enter="newTag"
        v-on:search="load">
        <template #noResults="{ search }">
            <div v-if="search !== ''"
                 @click="newTag(search)"
                 role="button"
                 class="d-flex justify-content-between border-radius bg-gray-100 p-1 ps-3 align-items-center">
                <label class="large">{{ search }}</label>
                <span class="small btn btn-success btn-sm">
                    {{ trans('general.defaults.add')}}
                    <i class="fi fi-rr-arrow-turn-down-left"></i>
                </span>
            </div>
            <div v-else>
                {{ trans('general.defaults.no_results_found') }}
            </div>
        </template>
    </k-select>
</template>

<script>
import axios from "axios";
import KSelect from "./KSelect.vue";

export default {
    name: "AllergiesSelect",
    props: {
        value: {
            type: Array,
            required: false,
            default: [],
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    components: {KSelect},
    data() {
        return {
            selected: this.value,
            options: [],
            taggableItems: [],
        }
    },
    watch: {
        value: {
            handler: function (val) {
                this.selected = val;
            },
            deep: true
        },
        selected: {
            handler: function (val) {
                this.$emit('input', val);
                this.$emit('update', val);
            },
            deep: true
        }
    },
    methods: {
        newTag(tag) {
            if (tag.length > 2 && !this.options.some(o => o.label === tag)) {
                const newTag = { id: tag, label: tag };

                this.selected.push(newTag);
                this.taggableItems.push(newTag);
                this.options.push(newTag);

                this.$refs.allergies.setSearchQuery('');
            }
        },

        load(search = '') {
            const lang = document.documentElement.lang === 'sq';
            axios.get(`/allergies?search=${search}&search_fields=name:like;name_sq:like&limit=6`)
                .then(response => {
                    this.options = response.data.data
                        .map(a => ({ id: a.id, label: lang ? (a.name_sq || a.name) : a.name }))
                        .concat(this.taggableItems)
                        .sort((a, b) => a.label.localeCompare(b.label));
                });
        }
    },
    mounted() {
        this.load();
    }
}
</script>

<style scoped>

</style>
